var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgReasoningIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5609 13.5087L12.6739 14.6217C12.9522 14.9 13.3696 14.9 13.6478 14.6217L14.6217 13.6478C14.9 13.3696 14.9 12.9522 14.6217 12.6739L13.5087 11.5609C13.8565 10.9348 14.0652 10.2391 14.2043 9.54348H15.7348C16.1522 9.54348 16.4304 9.26522 16.4304 8.84783V8.15217C16.4304 7.73478 16.1522 7.45652 15.7348 7.45652H14.2043C14.0652 6.76087 13.8565 6.06522 13.5087 5.43913L14.6217 4.32609C14.9 4.04783 14.9 3.63043 14.6217 3.35217L13.6478 2.37826C13.3696 2.1 12.9522 2.1 12.6739 2.37826L11.5609 3.4913C10.9348 3.14348 10.2391 2.93478 9.54348 2.79565V1.19565C9.54348 0.778261 9.26522 0.5 8.84783 0.5H8.15217C7.73478 0.5 7.45652 0.778261 7.45652 1.19565V2.72609C6.76087 2.86522 6.06522 3.07391 5.43913 3.42174L4.32609 2.3087C4.04783 2.03043 3.63043 2.03043 3.35217 2.3087L2.37826 3.28261C2.1 3.56087 2.1 3.97826 2.37826 4.25652L3.4913 5.36957C3.14348 5.99565 2.93478 6.6913 2.79565 7.38696H1.19565C0.778261 7.38696 0.5 7.66522 0.5 8.08261V8.77826C0.5 9.19565 0.778261 9.47391 1.19565 9.47391H2.72609C2.86522 10.1696 3.07391 10.8652 3.42174 11.4913L2.3087 12.6043C2.03043 12.8826 2.03043 13.3 2.3087 13.5783L3.28261 14.5522C3.56087 14.8304 3.97826 14.8304 4.25652 14.5522L5.36957 13.4391",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45654 14.4131H9.5435",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45654 15.8047H9.5435",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 15.8047V16.5003",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6044 8.50006C12.6044 6.27397 10.7262 4.60441 8.5001 4.67397C6.27401 4.67397 4.46532 6.34354 4.39575 8.50006C4.46532 10.2392 5.71749 11.7696 7.45662 12.187V12.9522H9.54358V12.187C11.2827 11.7696 12.5349 10.2392 12.6044 8.50006Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReasoningIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ReasoningIcon.3de687d2769ce272ab7e60003368d641.svg";